import { OurServices_IMG } from '../Constants/ImageConstants'
import BannerSection from '../Feature/Common/BannerSection'
import ProgramsForEveryone from '../Feature/OurServices/ProgramsForEveryone'
import ProgramsHeaderSection from '../Feature/OurServices/ProgramsHeaderSection'

const OurServices = () => {
  const data = {
    title: "Programs",
    description: "Programs For Everyone",
    image: OurServices_IMG.Baner_img,
    buttonText: "Learn More",
    buttonLink: "/about"
  };
  return (

    <div>
      <BannerSection data={data}/>
      <ProgramsHeaderSection />
      <ProgramsForEveryone/>
    </div>
  )
}

export default OurServices
